var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("VerDetalleUsoVacacion"),
      _vm._v(" "),
      _c("VerDetalle"),
      _vm._v(" "),
      _c("VerReporte"),
      _vm._v(" "),
      _c("VerReprogramaciones"),
      _vm._v(" "),
      _c("AprobarReprogramacionRRHH"),
      _vm._v(" "),
      _c("AprobarUsoRRHH"),
      _vm._v(" "),
      _c("ReprogramarCronograma"),
      _vm._v(" "),
      _c("RechazarReprogramacionJefe"),
      _vm._v(" "),
      _c("EditarReprogramacionRechazada"),
      _vm._v(" "),
      _c("EditarReprogramacionRechazadaRRHH"),
      _vm._v(" "),
      _c("SolicitarEjecucionVacacion"),
      _vm._v(" "),
      _c("VolverEstadoInicialProgramacion"),
      _vm._v(" "),
      _c("VerPermiso"),
      _vm._v(" "),
      _c("AnularPermiso"),
      _vm._v(" "),
      _c("AprobarRRHHSinPermisos"),
      _vm._v(" "),
      _c("EditarPermisoCargoVacacion"),
      _vm._v(" "),
      _c("RechazarPermisoRRHH"),
      _vm._v(" "),
      _c("CrearPermisoCargoVacacion"),
      _vm._v(" "),
      _c("CabeceraDuodecima"),
      _vm._v(" "),
      _c("VerReportePapeletaV"),
      _vm._v(" "),
      _c("VerDocumento"),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c(
            "v-flex",
            { attrs: { shrink: "" } },
            [
              _c(
                "v-btn",
                {
                  attrs: { icon: "", color: "primary", to: "/vacaciones/rrhh" }
                },
                [_c("v-icon", [_vm._v("arrow_back")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("v-flex", { attrs: { xs10: "" } }, [
            _c(
              "h3",
              { staticClass: "primary--text" },
              [
                _c("v-icon", { attrs: { color: "primary" } }, [
                  _vm._v("today")
                ]),
                _vm._v(" Vacaciones programadas\n      ")
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("v-flex", { attrs: { xs12: "", md12: "" } }, [
            _c("h4", { staticStyle: { color: "#000" } }, [
              _c("b", [_vm._v("NOMBRE COMPLETO   :")]),
              _vm._v("  " + _vm._s(_vm.nombres) + "\n      ")
            ])
          ]),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs6: "", md6: "" } },
            [
              _c("v-autocomplete", {
                staticClass: "text-field-reducido-border",
                attrs: {
                  items: _vm.lista_gestiones,
                  "item-text": "periodo",
                  "item-value": "periodo",
                  label: "Seleccione la gestión",
                  required: "",
                  outline: "",
                  success: "",
                  clearable: ""
                },
                on: {
                  input: function($event) {
                    return _vm.cargarVacacionesProgramadas(
                      _vm.periodo_seleccionado
                    )
                  }
                },
                model: {
                  value: _vm.periodo_seleccionado,
                  callback: function($$v) {
                    _vm.periodo_seleccionado = $$v
                  },
                  expression: "periodo_seleccionado"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c(
            "v-flex",
            { attrs: { shrink: "" } },
            [
              _c(
                "v-tooltip",
                { attrs: { bottom: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { slot: "activator", color: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.crearPermisoCargoVacacion()
                        }
                      },
                      slot: "activator"
                    },
                    [
                      _c("v-icon", [_vm._v("event_note")]),
                      _vm._v(" Nueva Solicitud\n        ")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", [_vm._v("Nueva solicitud con cargo a vacación")])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { shrink: "" } },
            [
              _c(
                "v-tooltip",
                { attrs: { bottom: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        slot: "activator",
                        dark: "",
                        color: "rgb(87,51,204)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.cabeceraDuodecima({})
                        }
                      },
                      slot: "activator"
                    },
                    [
                      _c("v-icon", [_vm._v("add")]),
                      _vm._v(" Ver duodécimas\n        ")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", [_vm._v("Ver duodécima")])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("v-flex", { attrs: { shrink: "" } })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-tooltip",
        { attrs: { bottom: "" } },
        [
          _c(
            "v-btn",
            {
              staticClass: "btn-refresh",
              attrs: { slot: "activator" },
              nativeOn: {
                click: function($event) {
                  return function() {
                    _vm.filterShow = _vm.filterShow ? false : true
                  }.apply(null, arguments)
                }
              },
              slot: "activator"
            },
            [_c("v-icon", [_vm._v("filter_list")])],
            1
          ),
          _vm._v(" "),
          _c("span", [_vm._v("Búsqueda/filtros")])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-tooltip",
        { attrs: { bottom: "" } },
        [
          _c(
            "v-btn",
            {
              staticClass: "btn-refresh",
              attrs: { slot: "activator" },
              nativeOn: {
                click: function($event) {
                  return _vm.cargarVacacionesProgramadas(
                    _vm.periodo_seleccionado
                  )
                }
              },
              slot: "activator"
            },
            [_c("v-icon", [_vm._v("refresh")])],
            1
          ),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.$t("common.updateList")))])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { attrs: { xs12: "" } },
        [
          _c("transition", { attrs: { name: "slide-fade" } }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.filterShow,
                    expression: "filterShow"
                  }
                ],
                staticClass: "filter-container-rrhh"
              },
              [
                _c("v-icon", { attrs: { small: "", color: "primary" } }, [
                  _vm._v("search")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "filter-item" },
                  [
                    _c("v-text-field", {
                      attrs: { label: "Nro" },
                      on: { input: _vm.filterNumero },
                      model: {
                        value: _vm.form.numero,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "numero", $$v)
                        },
                        expression: "form.numero"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "filter-item" },
                  [
                    _c("v-text-field", {
                      attrs: { label: "Fecha desde", type: "date" },
                      on: { input: _vm.filterFechaDesde },
                      model: {
                        value: _vm.form.fecha_desde,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "fecha_desde", $$v)
                        },
                        expression: "form.fecha_desde"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "filter-item" },
                  [
                    _c("v-text-field", {
                      attrs: { label: "Fecha hasta", type: "date" },
                      on: { input: _vm.filterFechaHasta },
                      model: {
                        value: _vm.form.fecha_hasta,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "fecha_hasta", $$v)
                        },
                        expression: "form.fecha_hasta"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "filter-item" },
                  [
                    _c("v-text-field", {
                      attrs: { label: "Días programados", type: "number" },
                      on: { input: _vm.filterDias },
                      model: {
                        value: _vm.form.dias,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "dias", $$v)
                        },
                        expression: "form.dias"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "filter-item" },
                  [
                    _c("v-text-field", {
                      attrs: { label: "Tipo", type: "text" },
                      on: { input: _vm.filterTipo },
                      model: {
                        value: _vm.form.tipo,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "tipo", $$v)
                        },
                        expression: "form.tipo"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "filter-item" },
                  [
                    _c("v-text-field", {
                      attrs: { label: "Estado" },
                      on: { input: _vm.filterEstado },
                      model: {
                        value: _vm.form.estado,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "estado", $$v)
                        },
                        expression: "form.estado"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "filter-item" },
                  [
                    _c("v-text-field", {
                      attrs: { label: "Fecha solicitud", type: "date" },
                      on: { input: _vm.filterFechaSolicitud },
                      model: {
                        value: _vm.form.fecha_solicitud,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "fecha_solicitud", $$v)
                        },
                        expression: "form.fecha_solicitud"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "btn-filter" },
                  [
                    _c(
                      "v-tooltip",
                      { attrs: { bottom: "" } },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: { slot: "activator", icon: "", small: "" },
                            nativeOn: {
                              click: function($event) {
                                return _vm.recargar()
                              }
                            },
                            slot: "activator"
                          },
                          [
                            _c("v-icon", { attrs: { small: "" } }, [
                              _vm._v("refresh")
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("span", [_vm._v("Recargar filtros")])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-tooltip",
                      { attrs: { bottom: "" } },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: { slot: "activator", icon: "" },
                            nativeOn: {
                              click: function($event) {
                                return function() {
                                  _vm.filterShow = false
                                }.apply(null, arguments)
                              }
                            },
                            slot: "activator"
                          },
                          [
                            _c("v-icon", { attrs: { small: "" } }, [
                              _vm._v("close")
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("span", [_vm._v("Cerrar filtros")])
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            [
              _c("v-data-table", {
                staticClass: "elevation-1 tabla-comprimida-light",
                attrs: {
                  items: _vm.lista_vacaciones,
                  headers: _vm.headers,
                  "disable-initial-sort": true,
                  "item-key": "numero",
                  loading: _vm.loading,
                  "no-data-text": "No se tiene registros",
                  "no-results-text": "No se encontraron coincidencias",
                  search: _vm.filters,
                  "custom-filter": _vm.customFilter,
                  "rows-per-page-items": [20, 40, { text: "Todos", value: -1 }]
                },
                scopedSlots: _vm._u([
                  {
                    key: "headers",
                    fn: function(props) {
                      return [
                        _c(
                          "tr",
                          _vm._l(props.headers, function(header) {
                            return _c(
                              "th",
                              {
                                key: header.text,
                                class: [
                                  "column sortable",
                                  _vm.pagination.descending ? "desc" : "asc",
                                  header.value === _vm.pagination.sortBy
                                    ? "active"
                                    : ""
                                ],
                                on: {
                                  click: function($event) {
                                    return _vm.changeSort(header.value)
                                  }
                                }
                              },
                              [
                                header.value
                                  ? _c(
                                      "v-icon",
                                      { attrs: { small: "", color: "white" } },
                                      [_vm._v("arrow_upward")]
                                    )
                                  : _vm._e(),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(header.text) +
                                    "\n            "
                                )
                              ],
                              1
                            )
                          }),
                          0
                        )
                      ]
                    }
                  },
                  {
                    key: "items",
                    fn: function(items) {
                      return [
                        _c(
                          "tr",
                          {
                            class:
                              items.item.tipo == "P"
                                ? "celdaP"
                                : items.item.tipo == "R"
                                ? "celdaR"
                                : items.item.tipo == "VC"
                                ? "celdaVC"
                                : "celdaFR"
                          },
                          [
                            _c(
                              "td",
                              { staticClass: "text-xs-center py-0 px-1" },
                              [_vm._v(_vm._s(items.item.numero))]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticClass: "text-xs-center py-0 px-1" },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(items.item.fecha_desde) +
                                    "\n            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticClass: "text-xs-center py-0 px-1" },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(items.item.fecha_hasta) +
                                    "\n            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticClass: "text-xs-center py-0 px-1" },
                              [_vm._v(_vm._s(items.item.dias))]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticClass: "text-xs-center py-0 px-1" },
                              [_vm._v(_vm._s(items.item.tipo))]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticClass: "text-xs-center py-0 px-1" },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      items.item.id_estado == 70
                                        ? "Reprogramado Aprobado"
                                        : items.item.id_estado == 7
                                        ? "Aprobada Inmediato Superior"
                                        : items.item.estado
                                        ? items.item.estado
                                        : ""
                                    ) +
                                    "\n            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticClass: "text-xs-center py-0 px-1" },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      items.item.jefe_enviado &&
                                        (items.item.id_estado == 55 ||
                                          items.item.id_estado == 58 ||
                                          items.item.id_estado == 68 ||
                                          items.item.id_estado == 69 ||
                                          items.item.id_estado == 6 ||
                                          items.item.id_estado == 7)
                                        ? items.item.jefe_enviado
                                        : ""
                                    ) +
                                    "\n            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticClass: "text-xs-center py-0 px-1" },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(items.item.fecha_solicitud) +
                                    "\n            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticClass: "text-xs-center py-0 px-1" },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(items.item.justificacion_rechazo) +
                                    "\n            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticClass: "text-xs-center py-0 px-1" },
                              [
                                _c(
                                  "v-chip",
                                  {
                                    staticClass: "chip-multilinea",
                                    attrs: {
                                      color:
                                        items.item.dias_faltantes > 0 &&
                                        items.item.tipo != "FR" &&
                                        items.item.tipo != "VC"
                                          ? "#00D092"
                                          : items.item.dias_faltantes < 0 &&
                                            items.item.id_estado != 57 &&
                                            items.item.id_estado != 65 &&
                                            items.item.tipo != "FR" &&
                                            items.item.tipo != "VC"
                                          ? "#d6232e"
                                          : items.item.dias_faltantes == 0 &&
                                            items.item.tipo != "FR" &&
                                            items.item.tipo != "VC"
                                          ? "#00D092"
                                          : "",
                                      "text-color": "white"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          items.item.dias_faltantes > 0 &&
                                            items.item.tipo != "FR" &&
                                            items.item.tipo != "VC"
                                            ? "Falta " +
                                                items.item.dias_faltantes +
                                                " días para hacer uso de su vacación"
                                            : items.item.dias_faltantes < 0 &&
                                              items.item.id_estado != 57 &&
                                              items.item.id_estado != 65 &&
                                              items.item.tipo != "FR" &&
                                              items.item.tipo != "VC"
                                            ? "Programación vencida"
                                            : items.item.dias_faltantes == 0 &&
                                              items.item.tipo != "FR" &&
                                              items.item.tipo != "VC"
                                            ? "Hoy es la fecha del uso de su vacación"
                                            : ""
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticClass: "text-xs-center py-0 px-1" },
                              [
                                _c(
                                  "v-tooltip",
                                  { attrs: { bottom: "" } },
                                  [
                                    items.item.id_estado != 82
                                      ? _c("v-checkbox", {
                                          attrs: {
                                            slot: "activator",
                                            primary: "",
                                            "hide-details": ""
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.documentoEntregado(
                                                items.item
                                              )
                                            }
                                          },
                                          slot: "activator",
                                          model: {
                                            value: items.item.entregado,
                                            callback: function($$v) {
                                              _vm.$set(
                                                items.item,
                                                "entregado",
                                                $$v
                                              )
                                            },
                                            expression: "items.item.entregado"
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          items.item.entregado
                                            ? "Desmarcar"
                                            : "Marcar"
                                        )
                                      )
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            items.item.tipo == "P" ||
                            items.item.tipo == "R" ||
                            items.item.tipo == "FR"
                              ? _c(
                                  "td",
                                  { staticClass: "py-0 px-1 btn-comprimido" },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          color: "#3dca24",
                                          icon: "",
                                          dark: "",
                                          title: "Ver detalle"
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.verDetalle(items.item)
                                          }
                                        }
                                      },
                                      [
                                        _c("v-icon", [_vm._v("remove_red_eye")])
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    items.item.id_estado == 55 ||
                                    items.item.id_estado == 72 ||
                                    items.item.id_estado == 58 ||
                                    items.item.id_estado == 70
                                      ? _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              color: "rgb(147,13,242)",
                                              dark: "",
                                              icon: "",
                                              title: "Aprobar uso de vacación"
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.aprobarUsoRRHH(
                                                  items.item
                                                )
                                              }
                                            }
                                          },
                                          [_c("v-icon", [_vm._v("done")])],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    items.item.id_estado_hijo == 68 ||
                                    items.item.id_estado_hijo == 69
                                      ? _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              color: "rgba( 36, 113, 163,0.7)",
                                              icon: "",
                                              dark: "",
                                              title: "Aprobar reprogramación"
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.aprobarReprogramacionRRHH(
                                                  items.item
                                                )
                                              }
                                            }
                                          },
                                          [_c("v-icon", [_vm._v("done")])],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    items.item.id_estado == 72 ||
                                    items.item.id_estado == 71 ||
                                    items.item.id_estado == 56
                                      ? _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              color: "rgb(242,94,13)",
                                              icon: "",
                                              dark: "",
                                              title: "Reprogramar"
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.editarReprogramacionRechazada(
                                                  items.item
                                                )
                                              }
                                            }
                                          },
                                          [_c("v-icon", [_vm._v("refresh")])],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    [57, 71].includes(
                                      parseInt(items.item.id_estado)
                                    )
                                      ? _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              color: "#4169e1",
                                              icon: "",
                                              dark: "",
                                              title: "Editar reprogramación"
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.EditarReprogConCorrelativo(
                                                  items.item
                                                )
                                              }
                                            }
                                          },
                                          [_c("v-icon", [_vm._v("edit")])],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    items.item.id_estado == 57 &&
                                    (items.item.id_estado_hijo == 68 ||
                                      items.item.id_estado_hijo == 69)
                                      ? _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              color: "#FF5D34",
                                              icon: "",
                                              dark: "",
                                              title: "Rechazar reprogramación"
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.rechazarReprogramacion(
                                                  items.item
                                                )
                                              }
                                            }
                                          },
                                          [_c("v-icon", [_vm._v("close")])],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    items.item.id_estado == 55 ||
                                    items.item.id_estado == 58
                                      ? _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              color: "rgb(255,179,0)",
                                              icon: "",
                                              dark: "",
                                              title:
                                                "Volver a estado inicial ---"
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.retrocederProgVacacion(
                                                  items.item
                                                )
                                              }
                                            }
                                          },
                                          [_c("v-icon", [_vm._v("reply")])],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    items.item.id_estado == 65 &&
                                    items.item.id_padre == null &&
                                    items.item.tipo == "P"
                                      ? _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              color: "rgb(255,179,0)",
                                              icon: "",
                                              dark: "",
                                              title: "Volver a estado inicial"
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.volverEstadoInicialProgramacion(
                                                  items.item
                                                )
                                              }
                                            }
                                          },
                                          [_c("v-icon", [_vm._v("reply")])],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    items.item.id_estado == 57 &&
                                    !items.item.estados_hijos
                                      .split(",")
                                      .map(function(ele) {
                                        return parseInt(ele)
                                      })
                                      .includes(55) &&
                                    !items.item.estados_hijos
                                      .split(",")
                                      .map(function(ele) {
                                        return parseInt(ele)
                                      })
                                      .includes(58) &&
                                    !items.item.estados_hijos
                                      .split(",")
                                      .map(function(ele) {
                                        return parseInt(ele)
                                      })
                                      .includes(65)
                                      ? _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              color: "rgb(145,26,230)",
                                              icon: "",
                                              dark: "",
                                              title: "Volver a estado inicial"
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.retrocederReprogVacacion(
                                                  items.item
                                                )
                                              }
                                            }
                                          },
                                          [_c("v-icon", [_vm._v("reply")])],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    (items.item.id_estado == 65 ||
                                      items.item.id_estado == 55 ||
                                      items.item.id_estado == 58) &&
                                    items.item.tipo == "P"
                                      ? _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              color: "rgba( 36, 113, 163,0.7)",
                                              icon: "",
                                              dark: "",
                                              title:
                                                "Ver reporte de programación de vacación"
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.verReporte(
                                                  items.item,
                                                  0
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("v-icon", [
                                              _vm._v("picture_as_pdf")
                                            ])
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    items.item.id_estado == 57 &&
                                    (items.item.id_estado_hijo == 70 ||
                                      items.item.id_estado_hijo == 55 ||
                                      items.item.id_estado_hijo == 58 ||
                                      items.item.id_estado_hijo == 65 ||
                                      items.item.id_estado_hijo == 68 ||
                                      items.item.id_estado_hijo == 69)
                                      ? _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              color: "rgba( 142, 68, 173 ,0.7)",
                                              icon: "",
                                              dark: "",
                                              title:
                                                "Ver reporte de reprogramación de vacación"
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.verReporte(
                                                  items.item,
                                                  2
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("v-icon", [
                                              _vm._v("picture_as_pdf")
                                            ])
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    items.item.id_estado != 65 &&
                                    items.item.id_estado != 57
                                      ? _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              color: "rgb(230,26,26)",
                                              icon: "",
                                              dark: "",
                                              title: "Anular programación"
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.anularCronograma(
                                                  items.item,
                                                  1
                                                )
                                              }
                                            }
                                          },
                                          [_c("v-icon", [_vm._v("delete")])],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    (items.item.id_estado == 65 ||
                                      items.item.id_estado == 55 ||
                                      items.item.id_estado == 58) &&
                                    items.item.tipo == "R"
                                      ? _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              color: "rgba( 36, 113, 163,0.7)",
                                              icon: "",
                                              dark: "",
                                              title:
                                                "Ver reporte de reprogramación de vacación"
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.verReporte(
                                                  items.item,
                                                  1
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("v-icon", [
                                              _vm._v("picture_as_pdf")
                                            ])
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            items.item.tipo == "VC"
                              ? _c(
                                  "td",
                                  { staticClass: "btn-comprimido" },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          color: "info",
                                          dark: "",
                                          icon: "",
                                          title: "Ver permiso"
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.verPermiso(items.item)
                                          }
                                        }
                                      },
                                      [
                                        _c("v-icon", [_vm._v("remove_red_eye")])
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    items.item.id_estado == 22
                                      ? _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              color: "warning",
                                              icon: "",
                                              title: "Modificar"
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.editarPermisoCargoVacacion(
                                                  items.item
                                                )
                                              }
                                            }
                                          },
                                          [_c("v-icon", [_vm._v("edit")])],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    items.item.id_estado == 22
                                      ? _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              color: "red",
                                              icon: "",
                                              title: "Anular",
                                              dark: ""
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.anularPermiso(
                                                  items.item
                                                )
                                              }
                                            }
                                          },
                                          [_c("v-icon", [_vm._v("delete")])],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    items.item.id_estado == 6 ||
                                    items.item.id_estado == 77 ||
                                    items.item.id_estado == 7 ||
                                    items.item.id_estado == 75 ||
                                    items.item.id_estado == 21
                                      ? _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              color: "rgba( 36, 113, 163,0.7)",
                                              icon: "",
                                              dark: "",
                                              title:
                                                "Ver reporte papeleta con cargo a vacación"
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.verReportePapeletaV(
                                                  items.item
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("v-icon", [
                                              _vm._v("picture_as_pdf")
                                            ])
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "v-tooltip",
                                      { attrs: { bottom: "" } },
                                      [
                                        items.item.id_estado == 22 ||
                                        items.item.id_estado == 21 ||
                                        items.item.id_estado == 7 ||
                                        items.item.id_estado == 6
                                          ? _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  slot: "activator",
                                                  color: "warning",
                                                  icon: ""
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.preventDefault()
                                                    return _vm.aprobarRRHHSinPermisos(
                                                      items.item
                                                    )
                                                  }
                                                },
                                                slot: "activator"
                                              },
                                              [
                                                _c("v-icon", [
                                                  _vm._v("done_all")
                                                ])
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("span", [_vm._v("Aprobar vacación")])
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    [6, 22, 7, 75, 77].includes(
                                      parseInt(items.item.id_estado)
                                    )
                                      ? _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              color: [75, 77].includes(
                                                parseInt(items.item.id_estado)
                                              )
                                                ? "rgb(145,26,230)"
                                                : "#E61C5B",
                                              icon: "",
                                              dark: "",
                                              title: [75, 77].includes(
                                                parseInt(items.item.id_estado)
                                              )
                                                ? "Volver a estado inicial"
                                                : "Rechazar"
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.rechazarPermisoRRHH(
                                                  items.item
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("v-icon", [
                                              _vm._v(
                                                _vm._s(
                                                  [75, 77].includes(
                                                    parseInt(
                                                      items.item.id_estado
                                                    )
                                                  )
                                                    ? "reply"
                                                    : "close"
                                                )
                                              )
                                            ])
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b07d0010", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b07d0010","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/vacacion_rrhh/VacacionesProgramadasPorServidorRRHH.vue
// module id = null
// module chunks = 